export const extractApiErrorMessage = error => {
  const data = error?.response?.data;
  if (!data) return null;
  if (typeof data === 'string') return data;
  if (Array.isArray(data)) {
    return typeof data[0] === 'string' ? data[0] : null;
  }

  return (
    data?.lines?.non_field_errors?.[0] ??
    data?.non_field_errors?.[0] ??
    data?.detail ??
    null
  );
};
